import { render, staticRenderFns } from "./HomeDeleteRequest.vue?vue&type=template&id=6a234b54"
import script from "./HomeDeleteRequest.vue?vue&type=script&lang=js"
export * from "./HomeDeleteRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports